import LoginForm from '../components/login/login-form';
import Logo from "@/assets/Logo";

export default function LoginPage() {
    return (
        <main className="flex items-center justify-center md:h-screen">
            <div className="relative mx-auto flex w-full max-w-[400px] flex-col space-y-2.5 p-4 md:-mt-32">
                <div className="flex h-20 w-full items-end rounded-lg bg-purple-500 p-3 md:h-36">
                    <Logo path={"/logos/tulu-white.svg"} styles={{}}/>
                    {/*<p className="text-4xl font-bold text-white md:text-6xl">TULU</p>*/}
                    <div className="w-32 text-white md:w-36">
                    </div>
                </div>
                <LoginForm/>
            </div>
        </main>
    );
}